export default {
    en: {
        i_wrote_it          : "I wrote it {time}",
        user_wrote_it       : "{user} wrote it {time}",
        delete              : "Delete",
        type_a_message_here : "Type a message here",
        publish_your_message: "Publish your message",
        learn_more          : "Learn more about this demand"
    },
    el: {
        i_wrote_it          : "Το έγραψα {time}",
        user_wrote_it       : "{user} το έγραψε {time}",
        delete              : "Διαγραφή",
        type_a_message_here : "Γράψε εδώ το μήνυμα σου",
        publish_your_message: "Κοινοποίησε το μήνυμα σου",
        learn_more          : "Μάθε περισσότερα για αυτή τη ζήτηση"
    }
};